export default "__VITE_ASSET__6cb0bf77__"